import type { InferOutput } from 'valibot'
import { boolean, maxValue, minValue, nullish, number, object, optional, pipe } from 'valibot'

/**
 *  The schema for the body of a Solr response.
 */
export const baseBodySchema = object({
  numFound: number(),
  start: optional(pipe(number(), minValue(0), maxValue(10000))),
  numberFoundExact: nullish(boolean()),
})

export type BaseBody = InferOutput<typeof baseBodySchema>
